import React from 'react';
import { CircularProgress } from '@mui/material';
import './loader.scss';

const Loader = ({ fullScreen = false, size = 60, color = '#7451f8' }) => {
    return (
        <div className={`loader-container ${fullScreen ? 'full-screen' : ''}`}>
            <CircularProgress
                size={size}
                sx={{ color }}
                thickness={4}
            />
        </div>
    );
};

export default Loader;